import { useState, useEffect, useCallback, useContext, useRef } from "react"
import { useHistory } from 'react-router-dom';
import AuthorizedFunction from '@security/AuthorizedFunction';
import Grid from '@material-ui/core/Grid'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline'

import { formatarData } from "@helpers/DateHelper"
import ArrowForward from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add'

import { ProcessoContext } from "@contexts/ProcessoContext";
import Breadcrumbs from '@base/Breadcrumbs'
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Dialog from '@base/Dialog'
import DialogRemove from '@base/Dialog/DialogRemove'
import ButtonPrimary from '@base/Button'
import Filters from '@base/Filter'
import { ButtonCancel, ButtonSave } from '@base/Button/ButtonForm'
import TextField from '@base/Inputs/Text'
import { DatePicker } from '@base/Inputs/DatePicker/DatePicker'
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import ProcessoService from '@services/ProcessoService';
import { ReactSession } from 'react-client-session';

import { removePagingAndSorting } from '@helpers/PaginationHelper'
import { parseDate } from '@helpers/DateHelper'
import { redirectPaginaInicialDeAcordoComPerfil } from '@helpers/ProcessoHelper'

export const Processo = () => {

  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const [idExcluir, setIdExcluir] = useState();
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [list, setList] = useState([]);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('dataLimitePostagem')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const [id, setId] = useState("");
  const [nome, setNome] = useState("");
  const [dataLimitePostagem, setDataLimitePostagem] = useState("");
  const [dataInicioProcesso, setDataInicioProcesso] = useState("");
  const [dataFimProcesso, setDataFimProcesso] = useState("");
  const [, setIdTipoPendenciaDuplicidadeEnvelopeRecebido] = useState("");
  const [, setIdTipoPendenciaEscolaSemDocumentoEnvio] = useState("");
  const [, setIdTipoPendenciaPrioritaria] = useState("");
  const [, setIdTipoPendenciaDivergenciaDeCartoesComDE] = useState("");
  const [, setIdTipoPendenciaCartoesDeNivelSemAlunosInscritos] = useState("");
  const [, setIdTipoPendenciaCartoesDeMaisDeUmaEscola] = useState("");
  const [, setIdTipoPendenciaCartoesDeOutraEscola] = useState("");
  const [, setIdAtividadeTriagem] = useState("");
  const [, setPossuiLogo] = useState(false);
  const [, setObmepLogo] = useState({});

  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroNome, setFiltroNome] = useState();
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const context = useContext(ProcessoContext);
  const toastRef = useRef(null);

  const { setProcesso } = context;

  let history = useHistory();

  const pageName = 'Processos';
  const breadcrumbs = [];

  const aplicarFiltros = (ativo = false) => {
    let f = [];

    if (filtroNome) f.push({ field: 'nome', value: filtroNome });

    setFiltros(f);
    setFiltroAtivo(ativo);
    setQuantidadeFiltrosAplicados(f.length);
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }]);
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroNome('');

    setQuantidadeFiltrosAplicados(0);
  }

  const buttonAdd = () => {AuthorizedFunction(["__processo.editar"]) &&
    <Grid container spacing={3} >
      <Grid item xs={12} >
        <ButtonPrimary
          onClick={() => setOpenDialog(true)}
          name="Adicionar Novo Processo"
          startIcon={<AddIcon />}
        />
      </Grid>
    </Grid>}

  const buttonsSubmit = () =>
    <>
      <ButtonSave onClick={submit} />
      <ButtonCancel onBack={fecharModal} />
    </>

  const submit = () => {

    const config = { headers: { 'content-type': 'multipart/form-data' } };
    const request = new FormData();
    //request.append('nmArquivo', obmepLogo.name);
   // request.append('tipoArquivo', obmepLogo.type);
    //request.append('descricao', obmepLogo.description);
    //request.append('arquivo', obmepLogo);
    request.append("id", id);
    request.append("nome", nome);

   // if(idTipoPendenciaDuplicidadeEnvelopeRecebido)
   //   request.append("idTipoPendenciaDuplicidadeEnvelopeRecebido", idTipoPendenciaDuplicidadeEnvelopeRecebido);

   // if(idTipoPendenciaEscolaSemDocumentoEnvio)
   //   request.append("idTipoPendenciaEscolaSemDocumentoEnvio", idTipoPendenciaEscolaSemDocumentoEnvio);

   // if(idTipoPendenciaPrioritaria)
   //   request.append("idTipoPendenciaPrioritaria", idTipoPendenciaPrioritaria);
  //
  //  if(idTipoPendenciaCartoesDeMaisDeUmaEscola)
   //   request.append("idTipoPendenciaCartoesDeMaisDeUmaEscola", idTipoPendenciaCartoesDeMaisDeUmaEscola);

   // if(idTipoPendenciaCartoesDeOutraEscola)
   //   request.append("idTipoPendenciaCartoesDeOutraEscola", idTipoPendenciaCartoesDeOutraEscola);

   // if(idTipoPendenciaCartoesDeNivelSemAlunosInscritos)
   //   request.append("idTipoPendenciaCartoesDeNivelSemAlunosInscritos", idTipoPendenciaCartoesDeNivelSemAlunosInscritos);

   // if(idTipoPendenciaDivergenciaDeCartoesComDE)
   //   request.append("idTipoPendenciaDivergenciaDeCartoesComDE", idTipoPendenciaDivergenciaDeCartoesComDE);

   // if(idAtividadeTriagem)
   //   request.append("idAtividadeTriagem", idAtividadeTriagem);

    if(dataLimitePostagem)
      request.append("dataLimitePostagem", formatarData(dataLimitePostagem, "dd/MM/yyyy"));

    if(dataInicioProcesso)
      request.append("dataInicioProcesso", formatarData(dataInicioProcesso, "dd/MM/yyyy"));

    if(dataFimProcesso)
      request.append("dataFimProcesso", formatarData(dataFimProcesso, "dd/MM/yyyy"));

    if (!((nome) && (dataLimitePostagem) && (dataInicioProcesso) && (dataFimProcesso))) {
      toastRef.current.show("error", "Preencha todos os campos com asterisco!");
    } else {
      if (id) {
        ProcessoService.editar(id, request, config).then(resultado => {
          toastRef.current.show("success", "Processo Salvo com Sucesso!");
          fecharModal();
        }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Editar o Processo!"));
      } else {
        ProcessoService.adicionar(request, config).then(resultado => {
          toastRef.current.show("success", "Processo Salvo com Sucesso!");
          fecharModal();
        }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Criar um Novo Processo!"));
      }
    }
  };

  const submitExcluir = (id, setLoading) => {

    ProcessoService.excluir(id).then(resultado => {
      toastRef.current.show("success", "Processo Removido com Sucesso!");
    }).catch(error => {
      toastRef.current.show("error", error.response.data.mensagens.map(mensagen => mensagen).join(" ,"));
    }).finally(() => {
      fecharModalExcluir();
      setLoading(false);
    });

  };

  const abrirModalExclusao = (id) => {

    setOpenDialogRemove(true);
    setIdExcluir(id);

  };

  const acessarProcesso = (id) => {

    ProcessoService.listarUm(id).then(data => {
      setProcesso(data.data);
      ReactSession.set("responsavel_triagem", "");
      ReactSession.set("contador_triagem", 0);

      redirectPaginaInicialDeAcordoComPerfil(history,data.data.id);

    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar o Processo!"));

  };

  const tituloModalExclusao = () => `Excluir Processo`;

  const textoExcluir = () => `Lembre-se que apenas processos vazios (sem pendência ou escola) podem ser removidos!`;

  const fecharModalExcluir = () => {
    setOpenDialogRemove(false);
    setIdExcluir();

    carregarDados();
  }

  const abrirModal = (id) => {
    ProcessoService.listarUm(id).then(resultado => {

      const {
        id,
        nome,
        dataLimitePostagem,
        dataInicioProcesso,
        dataFimProcesso,
        idTipoPendenciaDuplicidadeEnvelopeRecebido,
        idTipoPendenciaEscolaSemDocumentoEnvio,
		    idTipoPendenciaPrioritaria,
        idTipoPendenciaDivergenciaDeCartoesComDE,
        idTipoPendenciaCartoesDeNivelSemAlunosInscritos,
        idTipoPendenciaCartoesDeMaisDeUmaEscola,
        idTipoPendenciaCartoesDeOutraEscola,
        idAtividadeTriagem,
        possuiLogo
      } = resultado.data;

      setId(id);
      setNome(nome);
      setDataLimitePostagem(parseDate(dataLimitePostagem));
      setDataInicioProcesso(parseDate(dataInicioProcesso));
      setDataFimProcesso(parseDate(dataFimProcesso));
      setIdTipoPendenciaDuplicidadeEnvelopeRecebido(idTipoPendenciaDuplicidadeEnvelopeRecebido);
      setIdTipoPendenciaEscolaSemDocumentoEnvio(idTipoPendenciaEscolaSemDocumentoEnvio);
      setIdTipoPendenciaPrioritaria(idTipoPendenciaPrioritaria);
      setIdTipoPendenciaDivergenciaDeCartoesComDE(idTipoPendenciaDivergenciaDeCartoesComDE);
      setIdTipoPendenciaCartoesDeNivelSemAlunosInscritos(idTipoPendenciaCartoesDeNivelSemAlunosInscritos);
      setIdTipoPendenciaCartoesDeMaisDeUmaEscola(idTipoPendenciaCartoesDeMaisDeUmaEscola);
      setIdTipoPendenciaCartoesDeOutraEscola(idTipoPendenciaCartoesDeOutraEscola);
      setIdAtividadeTriagem(idAtividadeTriagem);
      setOpenDialog(true);
      setPossuiLogo(possuiLogo);

    }).catch(error => toastRef.current.show("error", "Ocorreu um problema ao Buscar o Processo!"));

  }

  const tituloModal = () => `${id ? "Editar" : "Adicionar Novo"} Processo`;

  const fecharModal = () => {
    setOpenDialog(false);

    setId("");
    setNome("");
    setDataLimitePostagem("");
    setDataInicioProcesso("");
    setDataFimProcesso("");
    setObmepLogo({});

    carregarDados();
  };

  const columns = [
    { label: 'ID', name: 'id', func: null, key: true },
    { label: 'Nome do Processo', name: 'nome', func: null, key: false },
    { label: 'Data Limite de Postagem', name: 'dataLimitePostagem', func: null, key: false },
    { label: 'Data de Início do Processo', name: 'dataInicioProcesso', func: null, key: false },
    { label: 'Data de Fim do Processo', name: 'dataFimProcesso', func: null, key: false },
  ];

  const actions = [
   // {
   //   name: () => "Visualizar Logo",
    //  func: (id, obj) => {
     //   ProcessoService.downloadLogo(id).then(resultado => {
      //    const headers = resultado.headers['content-disposition'];
       //   const fname = headers.substring(headers.indexOf('=') + 1).replace("\"","").replace("\"","");
        //  FileDownload(resultado.data, fname);
        //}).catch(erro => {
         // toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
        //});
      //},
      //icon: <Wallpaper />,
      //disabled: (id, obj) => !obj.possuiLogo,
    //},
    {
      name: () => "Acessar Processo",
      func: acessarProcesso,
      icon: <ArrowForward />,
      disabled: () => false,
    },
  ]
  if (AuthorizedFunction(["__processo.editar"])) {
    actions.push({
      name: () => "Editar Processo",
      func: abrirModal,
      icon: <EditOutlinedIcon />,
      disabled: () => false,
    });
  }
  if (AuthorizedFunction(["__processo.excluir"])) {
    actions.push({
      name: () => "Excluir Processo",
      func: abrirModalExclusao,
      icon: <DeleteOutlinedIcon />,
      disabled: () => false,
      color: 'secondary'
    });
  }




  const carregarDados = useCallback(() => {

    const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);

    ProcessoService.filtrar(f).then(resultado => {
      const { content, number, size, totalElements, totalPages } = resultado.data;
      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"));

  }, [filtros, filtroAtivo, page, size, sort]);

  const handlePage = page => { setPage(page); setFiltroAtivo(true); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
    setFiltroAtivo(true);
  }

  const handleClearSort = (orderBy) => { setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs links={breadcrumbs} active={pageName} />
        </Grid>
      </Grid>
      <Title>{pageName}</Title>

      <Filters
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={3}>
          <Grid item sm={12} lg={4}>
            <TextField
              label='Nome do Processo'
              value={filtroNome}
              name='filtroNome'
              onChange={(e) => setFiltroNome(e.target.value)}
            />
          </Grid>
        </Grid>
      </Filters>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
      />

      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        closeDialog={fecharModal}
        openDialog={openDialog}
        title={tituloModal()}
        actions={buttonsSubmit()}
      >
        <Grid container spacing={3}>
          <Grid item lg={12}>
            <TextField
              label='Nome'
              required
              value={nome}
              name="nome"
              autoComplete="off"
              onChange={(e) => setNome(e.target.value)}
            />
          </Grid>

          <Grid item lg={4}>
            <DatePicker
              label={"Data de Início do Processo"}
              required
              value={dataInicioProcesso}
              name="dataInicioProcesso"
              onChange={(e) => setDataInicioProcesso(e)}
              disabled={false}
            />
          </Grid>

          <Grid item lg={4}>
            <DatePicker
              label={"Data de Fim de Processo"}
              required
              value={dataFimProcesso}
              name="dataFimProcesso"
              onChange={(e) => setDataFimProcesso(e)}
              disabled={false}
            />
          </Grid>

          <Grid item lg={4}>
            <DatePicker
              label={"Data Limite de Postagem"}
              required
              value={dataLimitePostagem}
              name="dataLimitePostagem"
              onChange={(e) => setDataLimitePostagem(e)}
              disabled={false}
            />
          </Grid>


{/*
          <Grid item lg={12}>
            { possuiLogo ?
              <Alert severity="warning">Uma logo já foi enviada para este processo, caso queira substituí-la utilize o botão abaixo.</Alert> :
              <Alert severity="info">Utilize o botão abaixo para inserir a logo do processo.</Alert>
            }
            <File obrigatorio={false} mensagemSobreRestricoes="Dimensão máxima: 200x250" handleUpload={(arquivo) => {
              setObmepLogo(arquivo);
            }} />
          </Grid>*/}
        </Grid>
      </Dialog>

      {buttonAdd()}

      <DialogRemove
        maxWidth={"sm"}
        id={idExcluir}
        text={textoExcluir()}
        close={fecharModalExcluir}
        open={openDialogRemove}
        title={tituloModalExclusao()}
        handleConfirm={submitExcluir}
      />
    </>
  );
}

export default Processo;

